module.exports = __webpack_public_path__ + "img/c00_buildingtechhorsemanship_Normal_ua.c1a1b8c1.webp";